export class GlobalData {
  
  private data = {}

  public set = (key , val) => {
    this.data[key] = val
  }

  public get = (key) => {
    return this.data[key]
  }
}

const globalData = new GlobalData();
export default globalData;